module.exports = __webpack_public_path__ + "static/media/tea_kokiri_logo.4e32ec7b.png";